// src/pages/Faturas.jsx
import { useState, useMemo } from 'react';
import { formatCurrency, formatDate, monthLabel, currentMonthKey, getEntryBillKey } from '../services/billing';

const CAT_COLOR = { Alimentação:'#34d39920', Moradia:'#6c8fff20', Transporte:'#60a5fa20', Saúde:'#f8717120', Lazer:'#e879f920', Educação:'#fbbf2420', Roupas:'#fb923c20', Outros:'#94a3b820' };
const CAT_TXT   = { Alimentação:'#34d399',   Moradia:'#6c8fff',   Transporte:'#60a5fa',   Saúde:'#f87171',   Lazer:'#e879f9',   Educação:'#fbbf24',   Roupas:'#fb923c',   Outros:'#94a3b8' };
const RAMPS = {
  blue:{dot:'#6c8fff'}, purple:{dot:'#a78bfa'}, teal:{dot:'#34d399'},
  coral:{dot:'#fb923c'}, pink:{dot:'#f472b6'}, amber:{dot:'#fbbf24'},
};

export default function Faturas({ cards, entries }) {
  const [cardFilter, setCardFilter] = useState('all');
  const [monthFilter, setMonthFilter] = useState('all');
  const now = currentMonthKey();

  const allBillKeys = useMemo(() => {
    const keys = [...new Set(entries.map(e => getEntryBillKey(e, cards)))].sort().reverse();
    return keys;
  }, [entries, cards]);

  const filteredCards  = cardFilter  === 'all' ? cards : cards.filter(c => c.id === cardFilter);
  const filteredMonths = monthFilter === 'all' ? allBillKeys : [monthFilter];

  const billData = useMemo(() => {
    const result = [];
    filteredMonths.forEach(mk => {
      filteredCards.forEach(c => {
        const ces = entries.filter(e => e.cardId === c.id && getEntryBillKey(e, cards) === mk);
        if (!ces.length) return;
        result.push({ card: c, billKey: mk, entries: ces, total: ces.reduce((s, e) => s + e.val, 0) });
      });
    });
    return result;
  }, [filteredMonths, filteredCards, entries, cards]);

  return (
    <div className="content">
      <div className="page-header">
        <div>
          <div className="page-title">Faturas</div>
          <div className="page-subtitle">Histórico de faturas por cartão</div>
        </div>
      </div>

      <div className="chips-row">
        <button className={`chip${cardFilter === 'all' ? ' active' : ''}`} onClick={() => setCardFilter('all')}>Todos os cartões</button>
        {cards.map(c => (
          <button key={c.id} className={`chip${cardFilter === c.id ? ' active' : ''}`} onClick={() => setCardFilter(c.id)}>{c.name}</button>
        ))}
      </div>

      <div className="chips-row">
        <button className={`chip${monthFilter === 'all' ? ' active' : ''}`} onClick={() => setMonthFilter('all')}>Todas</button>
        {allBillKeys.map(k => (
          <button key={k} className={`chip${monthFilter === k ? ' active' : ''}`} onClick={() => setMonthFilter(k)}>{monthLabel(k)}</button>
        ))}
      </div>

      {billData.length === 0 && (
        <div style={{ color: 'var(--text-3)', fontSize: 13, textAlign: 'center', padding: '3rem' }}>Nenhuma fatura encontrada.</div>
      )}

      {billData.map(({ card, billKey, entries: ces, total }) => {
        const r = RAMPS[card.color] || RAMPS.blue;
        const isOpen = billKey >= now;
        const sorted = [...ces].sort((a, b) => a.date.localeCompare(b.date));
        return (
          <div className="bill-card" key={card.id + billKey}>
            <div className="bill-card-header">
              <div>
                <div className="bill-card-name" style={{ color: r.dot }}>{card.name} · {monthLabel(billKey)}</div>
                <div className="bill-card-period">Fecha dia {card.closeDay} · Vence dia {card.dueDay}/{monthLabel(billKey).split('/')[1]}</div>
              </div>
              <span className={`badge ${isOpen ? 'badge-open' : 'badge-closed'}`}>{isOpen ? 'Aberta' : 'Fechada'}</span>
            </div>
            <div className="bill-card-total">{formatCurrency(total)}</div>
            <div className="bill-card-sub">{ces.length} lançamento{ces.length !== 1 ? 's' : ''}</div>

            <div className="table-wrap" style={{ marginBottom: 0 }}>
              <table>
                <thead>
                  <tr>
                    <th style={{ width: 90 }}>Data</th>
                    <th>Descrição</th>
                    <th style={{ width: 100 }}>Categoria</th>
                    <th style={{ width: 78 }}>Parcela</th>
                    <th style={{ width: 110 }}>Valor</th>
                  </tr>
                </thead>
                <tbody>
                  {sorted.map(e => (
                    <tr key={e.id}>
                      <td>{formatDate(e.date)}</td>
                      <td className="td-primary" title={e.desc}>{e.desc}</td>
                      <td>
                        <span className="badge" style={{ background: CAT_COLOR[e.cat], color: CAT_TXT[e.cat] }}>{e.cat}</span>
                      </td>
                      <td>
                        {e.type === 'parcel'
                          ? <span className="badge badge-parc">{e.parcelIdx}/{e.parcelTotal}</span>
                          : '—'}
                      </td>
                      <td className="td-primary">{formatCurrency(e.val)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        );
      })}
    </div>
  );
}
